import "./App.css";
import { Link } from "react-router-dom";

function OurTodos() {
  return (
    <div className="App">
      <div className="top">
        <div className="content">
          <span className="title"> OurTodos: To-Do & Planner App</span>
          <p className="desc" style={{ textAlign: "center" }}>
            Why make it complicated when you can keep it simple? Truly achieve
            your goals with OurTodos, the minimalist and straightforward task
            management app!
          </p>
          <div className="btns" style={{ color: "white" }}>
            Support mail:{" "}
            <a href="mailto:contact@charles-zimmerlin.com">
              contact@charles-zimmerlin.com
            </a>
            {/* <a
              href="https://apps.apple.com/us/app/dotoday-simple-to-do/id6458744179?itsct=apps_box_badge&amp;itscg=30200"
              className="appst"
            >
              <img
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/white/en-us?size=150x50&amp;releaseDate=1693526400"
                alt="Download on the App Store"
                className="appstImg"
                width={150}
                height={50}
              />
            </a> */}
          </div>
        </div>{" "}
      </div>
      <footer>
        <Link className="footerA" to="/confidentiality-ourtodos">
          Privacy Policy
        </Link>
        <span className="footerText">
          {" "}
          Copyright ©{new Date().getFullYear()}
        </span>
        <a
          className="footerA"
          href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
        >
          EULA
        </a>
      </footer>
    </div>
  );
}

export default OurTodos;
